import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageOutlined, MailOutlined, ThunderboltOutlined, RocketOutlined } from '@ant-design/icons';
import { message } from 'antd';

const channels = [
  {
    id: 'sms',
    icon: <MessageOutlined />,
    title: 'SMS Campaign',
    description: 'Send text messages to customers when your vehicles are nearby',
  },
  {
    id: 'email',
    icon: <MailOutlined />,
    title: 'Email Campaign',
    description: 'Send personalized emails to customers when your vehicles ar...',
  },
  {
    id: 'both',
    icon: <ThunderboltOutlined />,
    title: 'Both',
    description: 'Combine SMS and Email for maximum reach and engagement',
  },
];

const ChooseCampaignChannel = ({ selectedChannel, onUpdate, onNext, isLastStep = true }) => {
  const navigate = useNavigate();

  const handleSelect = (channelId) => {
    onUpdate(channelId);
  };

  const handleLaunchCampaign = () => {
    if (!selectedChannel) {
      message.warning('Please select a campaign channel first');
      return;
    }
    // TODO: Submit campaign data to API
    message.success('Campaign launched successfully!');
    navigate('/dashboard/client');
  };

  const handleContinue = () => {
    if (selectedChannel) {
      onNext();
    }
  };

  return (
    <div className="step-container">
      <h1 className="step-title">Choose Your Campaign Channel</h1>
      <p className="step-subtitle">How do you want to reach customers when your vehicles are nearby?</p>

      <div className="platform-grid">
        {channels.map((channel) => (
          <div
            key={channel.id}
            className={`platform-card ${selectedChannel === channel.id ? 'selected' : ''}`}
            onClick={() => handleSelect(channel.id)}
          >
            <div className="platform-icon">
              {channel.icon}
            </div>
            <div className="platform-title">{channel.title}</div>
            <p className="platform-description">{channel.description}</p>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="campaign-footer">
        <div className="footer-info">
          {selectedChannel ? `Choose a channel` : 'Choose a channel'}
        </div>
        {isLastStep ? (
          <button 
            className="launch-btn" 
            onClick={handleLaunchCampaign}
            disabled={!selectedChannel}
          >
            <RocketOutlined />
            Launch Campaign
          </button>
        ) : (
          <button 
            className="continue-btn" 
            onClick={handleContinue}
            disabled={!selectedChannel}
          >
            Continue
            <RocketOutlined />
          </button>
        )}
      </div>
    </div>
  );
};

export default ChooseCampaignChannel;
